import type { BoxProps } from "@qws-org/ui-kit";
import { Box } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, MainBanner, Pages } from "~/core";
import { CmsImage } from "~/shared/ui/CmsImage";

import { Column } from "./components/Column";
import { Row } from "./components/Row";

export type ImageParams = {
  format?:
    | "jpg"
    | "jpeg"
    | "png"
    | "gif"
    | "webp"
    | "avif"
    | "svg"
    | "bmp"
    | "ico"
    | "tiff";
  height?: number;
  width?: number;
};
export type MainBannerV2Props = {
  data: MainBanner;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  getImageUrl: (imageId: string, params?: ImageParams) => string;
  isControlInactive: (control: Action) => boolean;
  isFirstOnPage?: boolean;
} & BoxProps;
export type BannerVariant = "row" | "column";

const MAIN_BANNER_V2_WIDTH = 1920;
const MAIN_BANNER_V2_HEIGHT = 720;

const getBannerVariant = (data: MainBanner): BannerVariant => {
  return data.variant === "row" ? "row" : "column";
};

export const MainBannerV2: FC<MainBannerV2Props> = (props) => {
  const { data, isFirstOnPage, ...rest } = props;
  const bannerVariant = getBannerVariant(data);
  const hasImage = Boolean(data.backgroundImage?.id);

  return (
    <Box
      position={hasImage ? { type: "relative" } : undefined}
      bg={hasImage ? undefined : (data.backgroundColor ?? "")}
      {...rest}
      md={{
        bg: hasImage ? undefined : (data.backgroundColor ?? ""),
        ...rest.md,
      }}
      d={{
        bg: hasImage ? undefined : (data.backgroundColor ?? ""),
        ...rest.d,
      }}
      data-testid="main-banner"
    >
      {hasImage && data.backgroundImage && (
        <CmsImage
          id={data.backgroundImage.id}
          width={MAIN_BANNER_V2_WIDTH}
          height={MAIN_BANNER_V2_HEIGHT}
          alt=""
          priority={isFirstOnPage ?? false}
          className="absolute inset-0 w-full h-full object-cover -z-10"
        />
      )}
      {bannerVariant === "column" ? <Column {...props} /> : <Row {...props} />}
    </Box>
  );
};
